<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>{{ title }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6">
        <v-card elevation="0">
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="epicMapping in epicMappingList"
                :key="epicMapping.name"
                :to="{
                  name: `${epicMappingName}Preview`,
                  params: { entityName, id: epicMapping.id },
                }"
              >
                <v-list-item-avatar>
                  <v-icon small>fas fa-download</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ epicMapping.label }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>xlsx</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    epicMappingList() {
      const { epicMappingName } = this;

      const entityStore = this.$store.state[epicMappingName];

      if (!entityStore) {
        throw new Error(`No store found for "${epicMappingName}"`);
      }

      let { list } = entityStore;

      return list;
    },
    epicMappingName() {
      return `${this.entityName}EpicMapping`;
    },
  },
  async created() {
    const { epicMappingName } = this;

    try {
      await this.entityGetList({ reload: false });
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: `Unable to load ${epicMappingName} list` });
      return;
    }
  },
  methods: {
    async entityGetList() {
      const { epicMappingName } = this;

      return this.$store.dispatch(`${epicMappingName}/list`);
    },
  },
  props: {
    entityName: {
      required: true,
      type: String,
    },
    title: {
      required: true,
    },
  },
};
</script>
